"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var sound_player_sound_1 = require("./sound_player_sound");
function SoundPlayer(_a) {
    var soundList = _a.soundList, enableKeyBinding = _a.enableKeyBinding, onKeybindSelect = _a.onKeybindSelect;
    var isLoading = soundList.isLoading, categories = soundList.categories, sounds = soundList.sounds;
    var _b = (0, react_1.useState)(250), nameMaxWidth = _b[0], setNameMaxWidth = _b[1];
    // resize name width
    var elementRef = (0, react_1.useRef)(null);
    var resize = (0, react_1.useCallback)(function () {
        if (!elementRef.current)
            return;
        var soundElement = elementRef.current.getElementsByClassName('sound')[0];
        if (!soundElement)
            return;
        var soundOptionsElement = soundElement.getElementsByClassName('sound-options')[0];
        setNameMaxWidth(soundElement.clientWidth - soundOptionsElement.clientWidth - 30);
    }, [elementRef.current]);
    (0, react_1.useEffect)(function () {
        resize();
        window.addEventListener('resize', resize);
        return function () {
            window.removeEventListener('resize', resize);
        };
    }, [elementRef.current]);
    if (isLoading)
        return;
    var favorites = soundList.favorites.get();
    return ((0, jsx_runtime_1.jsxs)("div", { ref: elementRef, className: "sound-player", children: [favorites.length > 0 &&
                (0, jsx_runtime_1.jsxs)("div", { className: 'favorites', children: [(0, jsx_runtime_1.jsx)("h2", { children: "Favorites" }), (0, jsx_runtime_1.jsx)("div", { className: 'categories', children: favorites.map(function (_a) {
                                var soundId = _a.soundId;
                                var sound = soundList.sounds.get().find(function (sound) { return sound.id === soundId; });
                                return sound ? (0, jsx_runtime_1.jsx)(sound_player_sound_1.SoundPlayerSound, { sound: sound, soundList: soundList, nameMaxWidth: nameMaxWidth, enableKeyBinding: enableKeyBinding, onKeybindSelect: onKeybindSelect }) : null;
                            }) })] }), (0, jsx_runtime_1.jsx)("div", { className: "categories", children: categories.get().map(function (category) { return ((0, jsx_runtime_1.jsxs)("div", { className: "category", children: [(0, jsx_runtime_1.jsx)("h2", { className: "category-name", children: category.name }), (0, jsx_runtime_1.jsx)("div", { className: "sounds", children: sounds
                                .get()
                                .filter(function (sound) { return sound.categoryId === category.id; })
                                .map(function (sound) { return (0, jsx_runtime_1.jsx)(sound_player_sound_1.SoundPlayerSound, { sound: sound, soundList: soundList, nameMaxWidth: nameMaxWidth, enableKeyBinding: enableKeyBinding, onKeybindSelect: onKeybindSelect }); }) })] }, "category-".concat(category.id))); }) })] }));
}
exports.default = SoundPlayer;
